import Clipboard from "clipboard";
import Stickyfill from "stickyfilljs";

const sidebarSticky = () => {
  let lastId,
    sidebarMenu = $(".categories-list, .categories-select__list"),
    sidebarMenuHeight = sidebarMenu.outerHeight() + 15,

    menuItems = sidebarMenu.find("a"),

    scrollItems = menuItems.map(function () {
      let item = $($(this).attr("href"));
      if (item.length) {
        return item;
      }
    });

  menuItems.click(function (e) {
    let href = $(this).attr("href");
    let offsetTop = href === "#" ? 0 : $(href).offset().top - sidebarMenuHeight + 270;
    const tabletBreakpoint = 959;
    if ($(window).width() < tabletBreakpoint) {
      offsetTop = href === "#" ? 0 : $(href).offset().top - sidebarMenuHeight;
    }
    $('html, body').stop().animate({
      scrollTop: offsetTop
    }, 300);
    e.preventDefault();
  });

  $(window).scroll(function () {
    let fromTop = $(this).scrollTop() + 168;

    let currentMenuItem = scrollItems.map(function() {
      if ($(this).offset().top < fromTop)
        return this;
    });

    currentMenuItem = currentMenuItem[currentMenuItem.length - 1];
    let id = currentMenuItem && currentMenuItem.length ? currentMenuItem[0].id : "";

    if ($(this).scrollTop() < 80 || $(this).scrollTop() === 0) {
      $(".categories-list__item").first().addClass("is-active")
    }

    if (lastId !== id) {
      lastId = id;
      setTimeout(() => {
        menuItems
          .parent().removeClass("is-active")
          .end().filter("[href='#" + id + "']").parent().addClass("is-active");
      },50);
    }

    if ($(".categories-dropdown__item").hasClass("is-active")) {
      $(".categories-dropdown__item.is-active").closest(".categories-list__item").addClass("is-active");
      $(".categories-dropdown__item.is-active").parent().addClass("is-active");
    } else {
      $(".categories-dropdown__item.is-active").closest(".categories-list__item").removeClass("is-active");
      $(".categories-dropdown__item").parent().removeClass("is-active");
    }
  });
}

const selectDropdown = () => {
  $(".js-categories-select .categories-select__item--dropdown").on("click", function () {
    $(".categories-select__item--dropdown").not(this).removeClass("is-active");
    $(this).toggleClass("is-active");
  });


  $(".js-categories-select").on("click", function (e) {
    if (e.target !== this)
      return;
    $(".js-categories-select").toggleClass("is-open");
  });

  $(".categories-select-dropdown__link").on("click", function (e) {
    e.stopPropagation();
    $(".categories-select__item--dropdown").removeClass("is-active");
    $(".js-categories-select").removeClass("is-open");
  });
}

const clipBoardInit = () => {
  new Clipboard(".js-copy-link");
  $(".js-copy-link").on("click", function (e) {
    e.preventDefault();
  });
}

$(document).ready(function () {
  sidebarSticky();
  Stickyfill.add($(".categories"));
  selectDropdown();
  clipBoardInit();
});
